import {Component, Mixins} from 'vue-property-decorator'
import modalStepMixin from "@/mixins/modalStepMixin";
import formMixin from "@/mixins/formMixin";
import {
  IContact,
  IRequestExtended,
  IRequestServicePostData,
  IRequestServicePostSimpleData,
  RequestServicePost
} from "@/entities";

@Component
class modalItemContactMixin extends Mixins(modalStepMixin, formMixin) {

  private contactWays: number[] = [];
  protected form: IRequestServicePostSimpleData = modalItemContactMixin.clearForm();

  get key(): string | number {
    return this.$store.state.modal?.key;
  }

  get trimmedForm(): IRequestServicePostSimpleData {
    return {
      value: this.form.value?.trim()
    }
  }

  get postForm(): IRequestServicePostData {
    return {
      ...this.trimmedForm,
      contact_ways: this.contactWays,
      token: this.key.toString()
    }
  }

  private static clearForm(): IRequestServicePostSimpleData {
    return {
      value: ''
    }
  }

  protected submitOnSuccessAdditional(res?: any): void {
    this.form = modalItemContactMixin.clearForm();
  }
  protected submitOnSuccessAdditionalAsync(res?: any): void {
    (this.$refs['fields'] as any).reset();
  }

  protected actionPromise(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let request = new RequestServicePost(this.postForm);
      return this.$storage.actions.setRequestServiceContact({
        payload: request,
        config: {
          params: {
            status: 'waiting'
          }
        },
        key: this.subject.id
      })
        .then((res: IContact) => {
          this.subject.status = 'waiting';
          this.subject.contact = res;
          resolve();
        })
        .catch(reject);
    });
  }

  protected getActionData(): IRequestExtended<IRequestServicePostData> {
    return {
      payload: new RequestServicePost(this.postForm),
      key: this.subject.id
    }
  }

}

export default modalItemContactMixin
